module.exports = __webpack_public_path__ + "img/TrafficCritical.da979602.svg";